import { room,Video,CONV_STORAGE,socket,hideSideMenu, lockFocus, bottomAction, kinoTimer, timerComponent, userPreferences, muteMic, unMuteMic, volumeManager, muteMicButton, onStage,kinoParticipants} from '../libs/roomnew';
import TimerComponent from '../components/TimerComponent';
import moment from 'moment';
export default class StealFocus{
    constructor(){
        this.focusedIcon = `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px">
                <path fill="#032836" d="M12,2c-4.2,0-8,3.22-8,8.2c0,3.18,2.45,6.92,7.34,11.22c0.36,0.32,0.97,0.32,1.33,0C17.55,17.12,20,13.38,20,10.2 C20,5.22,16.2,2,12,2z M7.69,12.49C8.88,11.56,10.37,11,12,11s3.12,0.56,4.31,1.49C15.45,13.98,13.85,15,12,15 S8.55,13.98,7.69,12.49z M12,6c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C10,6.9,10.9,6,12,6z"/>
            </svg>`;
        this.focusedIconNotification = `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px">
                <path fill="#e0e4e5" d="M12,2c-4.2,0-8,3.22-8,8.2c0,3.18,2.45,6.92,7.34,11.22c0.36,0.32,0.97,0.32,1.33,0C17.55,17.12,20,13.38,20,10.2 C20,5.22,16.2,2,12,2z M7.69,12.49C8.88,11.56,10.37,11,12,11s3.12,0.56,4.31,1.49C15.45,13.98,13.85,15,12,15 S8.55,13.98,7.69,12.49z M12,6c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C10,6.9,10.9,6,12,6z"/>
            </svg>`;
        this.enabled=false;
        this.btnLabel=`Stage View`;
        this.btn=null;
        this.reUseTimeout=0;
        this.modal=$("#pullFocusModal");
        this.participantsList=$("#pullFocusParticipant");
        this.pullFocusTo=$("#pullFocusTo");
        this.errorMessage=$("#pullFocusErrorMessage");
        this.masterVolumeValue=$("#pull-focus-volume-slider");
        this.muteAllCheckBox=$("#pull-focus-mute-all-checkbox");
        this.lockMasterVolumeOnStage = $('#lock-master-volume-on-stage');
        this.minimizePullFocus=$('#minimize-pull-focus');
        this.participantFocused=null;
        this.unlockBanner=null;
        this.unlockFocusBtn=null;
        this.focusedOnMe=false;
        this.pullfocusOnJoinTimeout=0;
        this.pullFocusTimer = $('#pullFocusTimer');
        this.focusWasLocked;
        this.volumeMutedByOnStage=false;
        this.timerComponent=new TimerComponent();
        this.preferences={};
        this.masterVolumeLockPreviousState;
    };
    events(){
        var sf=this;

        sf.modal.on('keyup',function(e){
            if (e.keyCode == 27) {
                sf.hideStealFocusModal();
             }
        }).on('hidden.bs.modal', function(){
            sf.participantsList.removeAttr('selected_id')
        });

        // this.timerComponent.renderTimerComponent(sf.pullFocusTimer, true);
        this.timerComponent.renderTimerComponent(sf.pullFocusTimer);
        //handles preferences loaded from server
        userPreferences.registerFeatureHandler('pull_focus',(preferences)=>{
            if(!sf.isModerator()){return}
            // console.log(`Received pull focus preferences ${typeof preferences}`,preferences);
            if(typeof preferences == 'object' && Object.keys(preferences).length > 0){
                sf.preferences=preferences;
                sf.onPreferencesLoaded();
            }
        });

        socket.events.StealFocus=sf.stealFocusEvent.bind(sf);
        socket.events.ReleaseFocus=sf.releaseFocusEvent.bind(sf);
        socket.events.outOfConversation=(message)=>{
            if(CONV_STORAGE.myConversation && room.myUserId() == message.data.toParticipant){
                CONV_STORAGE.leaveSpace(false,false,true);
            }
        };
        //socket.events.unlockPullFocus=sf.unlockFocusEvent.bind(sf);
        sf.pullFocusTo.on('click',sf.startStealFocus.bind(sf));
        sf.masterVolumeValue.on('input',e=>{
            $("#pull-focus-volume").html(`${Math.round(parseFloat(sf.masterVolumeValue.val())*100)}`)
        });

        sf.minimizePullFocus.on('click', function(){
            console.log('button pressed')
            Video.minimizedContent.minimizeModal('pullFocusModal',sf.focusedIconNotification)
        });

        if(sf.isModerator()){
            // Video.localVideo.showPullFocusButtonForLocalUser();
        }
    };
    addOptionButton(){
        var s=this;
        s.enabled=true;
        if(s.btn !== null){return}
        s.optionIcon = $('<div/>', {
            class: "option-icon",
            id: "stealFocusIcon",
            html: s.focusedIcon,
        });
        s.optionName = $('<div/>', {
            class: "option-name",
            id: "option-name-steal-focus",
            html: s.btnLabel,
        });
        s.optionAction = $('<div/>', {
            class: "option-action",
            id: "option-action-steal-focus",
            html: '',
        });
        s.optionDescription = $('<div/>', {
            class: "option-description",
            html: [ s.optionName, s.optionAction],
        });
        s.btn = $('<div/>', {
            class: 'option',
            id: 'stealFocusBtn',
            html: [s.optionIcon, s.optionDescription],
        }).on('click',function(){
            s.showStealFocusModal();
            // onStage.startStageView();
            hideSideMenu();
        });
        $("#option-list").find("#stealFocusBtn").remove();
        $("#option-list").prepend(s.btn);
    };

    removeOptionButton(){
        var sf=this;
        sf.enabled=false;
        if(sf.btn !== null){
            sf.btn.remove();
        }
        sf.btn=null;
        sf.hideStealFocusModal();
        //sf.hideUnlockFocusButton();
        $("#kino-options-list").find("#stealFocusBtn").remove();
    };
    showStealFocusModal(){
        var sf=this;
        console.log('Clicked on show pull focus');
        if(sf.modal && sf.modal.hasClass('minimized-modal')){
            Video.minimizedContent.maximizeModal('pullFocusModal');
            return;
        }
        sf.hideError();
        // $("#pull-focus-volume").html(`5`);
        // sf.masterVolumeValue.val(0.05);
        // sf.onModalOpen();
        sf.enableModalButton();
        sf.listKinoParticipants();
        sf.modal.modal('show');

    };
    removeModal(modal){
        let i = this;
        modal.modal("hide");
        setTimeout(() => {
            if(modal !== null){
                modal.remove();
            }
        }, 200);
    };
    hideStealFocusModal(){
        var sf=this;
        sf.hideError();
        sf.modal.modal('hide');
    };
    setFocusedOnMe(data){
        let sf = this;
        sf.focusedOnMe=data!==false ? true : false;
        console.error("pull focus on me",sf.focusedOnMe);
        try {
            if(data){
                room.setLocalParticipantProperty('pulled_focus_on',JSON.stringify(data));
            }else{
              room.setLocalParticipantProperty('pulled_focus_on','');
            }

        } catch (error) {
            console.error("setFocused on me",error);
        }
    };
    listKinoParticipants(){
        var sf=this;
        let hosts=`<option disabled class="f-s-14">Host</option> `;
        // SEPARATOR
        // <option class="option-separator" disabled>&nbsp;</option>
        let moderators=`<option disabled class="f-s-14">Moderators</option>`;
        let participants=`<option disabled class="f-s-14">Participants</option>`;

        //add me
        let yourName = MY_NAME.length >= 30 ? MY_NAME.substring(0, 30) + "..." : MY_NAME;
        if(HOST==1){
            hosts+=`<option value='${room.myUserId()}' selected>${yourName} (me)</option>`;
        }else if(ROLE=='moderator'){
            moderators+=`<option value='${room.myUserId()}' selected>${yourName} (me)</option>`;
        }else{
            participants+=`<option value='${room.myUserId()}' selected>${yourName} (me)</option>`;
        }
        // $.each(Video.videos,function(pid,video){

        // });
        for (const pid in Video.videos) {
                const video = Video.videos[pid];
                let prole="none";
                let userName = video.displayName.length >= 30 ? video.displayName.substring(0, 30) + "..." : video.displayName;
                try {
                   prole=room.getParticipantById(pid).getProperty('role');
                } catch (error) {
                    console.log("failed to get role for ",pid);
                }
                if(prole=='host'){
                    hosts+=`<option value='${pid}'>${userName}</option>`;
                }else if(prole=="moderator"){
                    moderators+=`<option value='${pid}'>${userName}</option>`;
                }else{
                    participants+=`<option value='${pid}'>${userName}</option>`;
                }
        }
        sf.participantsList.html([hosts,moderators,participants]);
        console.log("All participants list",sf.participantsList);
        // if(sf.participantsList && sf.participantsList.attr('selected_id')){
        //     sf.participantsList.val(sf.participantsList.attr('selected_id'));
        // }
        // SORTING ALPHABETICALLY
        // sf.participantsList.append($("#pullFocusParticipant option").remove().sort(function(a, b) {
        //     var at = $(a).text(), bt = $(b).text();
        //     return (at > bt)?1:((at < bt)?-1:0);
        // }));

        // MULTIPLE SELECTIONS
        setTimeout(() => {
                  sf.participantsList.multiselect({
            maxHeight: 200
        });
        }, 2000);


    };
    async startStealFocus(){
        var sf=this;
        //check if user is in conversation
        if(!sf.enabled){return}
        // if(Object.keys(Video.videos).length==0){return}
        sf.hideError();
        console.error("PRESENTER TOOLTIP", Video.presenter.tooltip);
        if(Video.presenter.tooltip)Video.presenter.hideTooltip();
        let toParticipant=sf.participantsList.val();
        let masterVolumeValue=sf.masterVolumeValue.val();
        let lockFocusEnabled = true;
        let micMuted = sf.muteAllCheckBox.is(":checked") ? true : false;
        let lockMasterVolume = sf.lockMasterVolumeOnStage.is(':checked');
        let timerSeconds=0;
        console.log("Pull focus master volume",masterVolumeValue);
        let myId=room.myUserId();
        let participantName="";
        let delay=CONV_STORAGE.myConversation ? 0 : 0;
        sf.focusWasLocked = lockFocus.isLocked();
        sf.masterVolumeLockPreviousState = Video.lockMasterVolume.masterVolumeDisabled;
        console.log(`Clearing all spaces`);
        CONV_STORAGE.emptyAllSpaces();
        if(CONV_STORAGE.countDownInterval){
            clearInterval(CONV_STORAGE.countDownInterval);
            $('.undefined-notification').remove();
        }
        if(CONV_STORAGE.myConversation){
            let spc=CONV_STORAGE.getSpace(CONV_STORAGE.myConversation);
            if(spc.isPrivate()){
                delay=0;
            }
        }
        if(sf.timerComponent.isShown()){
            if(!sf.timerComponent.validateTimer()){
                return;
            }
        }
        //store preferences for pull focus
        sf.setNewPreferences({
            masterVolume:parseFloat(masterVolumeValue),
            lockFocus:lockFocusEnabled,
            muteAll:micMuted,
            lockMasterVolume: lockMasterVolume,
            timer: sf.timerComponent.isShown() ? {
                showNotification: sf.timerComponent.showTimesUpInput.is(':checked'),
                notificationShowTimeMinutes: sf.timerComponent.notificationTimeInputMinutes.val(),
                notificationShowTimeSeconds: sf.timerComponent.notificationTimeInputSeconds.val(),
                playNotificationSound: sf.timerComponent.playSoundCountdownInput.is(':checked'),
                minutes:sf.timerComponent.min,
                seconds:sf.timerComponent.sec
            } : false
        });
        sf.disableModalButton();

        if(lockMasterVolume){
            Video.lockMasterVolume.disableMasterVolume(true);
        }else if(!lockMasterVolume && Video.lockMasterVolume.masterVolumeDisabled){
            Video.lockMasterVolume.enableMasterVolume(true);
        }

        if(toParticipant==myId){
            participantName=MY_NAME;
            if(CONV_STORAGE.myConversation > 0){
                await CONV_STORAGE.leaveSpace(false,false,true);
            }
        }else{
            if(CONV_STORAGE.myConversation > 0){
                await CONV_STORAGE.leaveSpace(false,false,true);
            }
            if(Video.videos[toParticipant]!==undefined){
                // if(CONV_STORAGE.isOnConversation(toParticipant)){
                //     delay=3000;
                //     sf.sendOutOfConversation(toParticipant);
                // }
                participantName=Video.videos[toParticipant].displayName;
            }else{
                sf.setError("Couldn't find participant");
                sf.enableModalButton();
                return;
            }
        }

        //lockFocus.stopLockFocus();
        sf.disableStealFocus(true);
        if(Video.splitConversations.recurring && Video.splitConversations.recurring.runingTimerId){
            Video.splitConversations.stopRecurringSplit();
        }
        setTimeout(() => {
            sf.unfocusAll();
            // sf.sendStealFocusCommand(toParticipant,participantName,masterVolumeValue,lockFocusEnabled,micMuted);
            onStage.sendStartOnstage(toParticipant,{
                from_id: room.myUserId(),
                name:participantName,
                masterVolume: masterVolumeValue,
                lockFocus: lockFocus,
                micMuted: micMuted
            });
            if(sf.timerComponent.isShown()){
                sf.timerComponent.sendStartTimerCommand();
            }
            sf.participantFocused=toParticipant;
            if(toParticipant==myId){
                sf.setFocusedOnMe({
                    participant: toParticipant,
                    name:participantName,
                    masterVolume:masterVolumeValue,
                    lockFocus:lockFocusEnabled,
                    from_id:myId,
                    micMuted:micMuted
                });
                //set all as focused on me
                kinoParticipants.setAllAsFocusedMe();
                // if(Video.masterMuted){
                    sf.changeMasterVolume(1,true);
                // }

                // CHECK IF ON STAGE USER HAS HIS MIC OFF
                console.error("FOCUSED ON ME", sf.focusedOnMe);
                if (sf.focusedOnMe && room.getLocalAudioTrack().isMuted()) {
                    sf.renderMicMutedModal();
                }
            }else{
                sf.setFocusedOnMe(false);
                kinoParticipants.setAllAsUnFocusedMe();
                Video.focusVideo(toParticipant,'stealFocus',false,true);
                sf.changeMasterVolume(masterVolumeValue,true);
            }
            sf.showNotification("You",toParticipant,myId);
            if(lockFocusEnabled && !lockFocus.isLocked()){
                lockFocus.startLockFocus();
            }else if(!lockFocusEnabled && lockFocus.isLocked()){
                lockFocus.stopLockFocus();
            }
            sf.addReleaseFocusButton(sf.participantFocused);
        }, delay);

    };

    disableModalButton(){
        var sf=this;
        sf.pullFocusTo.attr('disabled','disabled');
        sf.pullFocusTo.html(`<i class="fas fa-circle-notch fa-spin"></i> Place on stage`);
    };
    enableModalButton(){
        var sf=this;
        sf.pullFocusTo.removeAttr('disabled');
        sf.pullFocusTo.html(`Place on stage`);
    };
    setError(message){
        this.errorMessage.html(`<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 15.5H13V17.5H11V15.5ZM11 7.5H13V13.5H11V7.5ZM11.99 2.5C6.47 2.5 2 6.98 2 12.5C2 18.02 6.47 22.5 11.99 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 11.99 2.5ZM12 20.5C7.58 20.5 4 16.92 4 12.5C4 8.08 7.58 4.5 12 4.5C16.42 4.5 20 8.08 20 12.5C20 16.92 16.42 20.5 12 20.5Z" fill="#FF3D00"></path></svg> ` + message);
    };
    hideError(){
        this.errorMessage.html("");
    };
    sendStealFocusCommand(toParticipant,name,volume,lockFocusEnabled,micMuted){
        var sf=this;
        sf.hideStealFocusModal();
        socket.sendRawMessage({
            eventName: "StealFocus",
            data: {
                participant: toParticipant,
                name:name,
                masterVolume:volume,
                lockFocus:lockFocusEnabled,
                room_id: room.getName(),
                from_id:room.myUserId(),
                micMuted
            },
            room_id:room.getName()
        });
    };
    sendOutOfConversation(toParticipant){
        socket.sendOutOfConversation(toParticipant);
    };
    async stealFocusEvent(message){
        var sf=this;
        console.error("Steal focus event", message);
        clearTimeout(sf.pullfocusOnJoinTimeout);
        if(CONV_STORAGE.countDownInterval){
            clearInterval(CONV_STORAGE.countDownInterval);
            $('.undefined-notification').remove();
        }
        try {
            if(Video.splitConversations.recurring && Video.splitConversations.recurring.runingTimerId){
                Video.splitConversations.stopRecurringSplit();
            }
            console.error("PRESENTER TOOLTIP", Video.presenter.tooltip);
            if(Video.presenter.tooltip)Video.presenter.hideTooltip();
            var data=message.data;
            let myid=room.myUserId();
            let myConversation=CONV_STORAGE.myConversation;
            console.log(`My conversation is `,myConversation);
            console.log("Clearing all spaces");
            CONV_STORAGE.emptyAllSpaces();

            sf.participantFocused=data.participant;
            if(data.participant==myid){
                sf.showNotification(data.name,data.participant,data.from_id);
                if(myConversation){
                   await CONV_STORAGE.leaveSpace(false,false,true);
                }
                sf.setFocusedOnMe({
                    participant: data.participant,
                    name:data.name,
                    masterVolume:data.masterVolume,
                    lockFocus:data.lockFocus,
                    from_id:data.from_id,
                    micMuted:data.micMuted
                });
                sf.unfocusAll();
                //set all as focused on me
                kinoParticipants.setAllAsFocusedMe();
                sf.addReleaseFocusButton(myid);
                // if(volumeManager.masterMuted){
                   sf.changeMasterVolume(1,true);
                // }
                // CHECK IF ON STAGE USER HAS HIS MIC OFF
                if (sf.focusedOnMe && room.getLocalAudioTrack().isMuted()) {
                    sf.renderMicMutedModal();
                }
                return
            }else{
                sf.setFocusedOnMe(false);
                if(data.micMuted){
                    if(Video.announcement.announcing){
                        Video.announcement.muteOnStopAnnouncing=true;
                    }else{
                        sf.setMicMuted();
                    }

                }
            }
            if(Video.focused[data.participant] && myConversation==null){
                console.log("Participant on stage after already focused",data.participant)
                sf.changeMasterVolume(data.masterVolume,true);
                return
            }
            sf.showNotification(data.name,data.participant,data.from_id);
            if(myConversation){
                await CONV_STORAGE.leaveSpace(false,false,true);
                console.log("Participant on stage after leaving space",data.participant)
                Video.focusVideo(data.participant,'stealFocus',false,true);
                sf.changeMasterVolume(data.masterVolume,true);

            }else{
                if(CONV_STORAGE.leaving){
                    await this.sleep(2);
                }
                sf.unfocusAll();
                kinoParticipants.setAllAsUnFocusedMe();
                Video.focusVideo(data.participant,'stealFocus',false,true);
                sf.changeMasterVolume(data.masterVolume,true);

            }

            if(data.participant==myid){
                sf.setFocusedOnMe(data);
            }else{
                sf.setFocusedOnMe(false);
            }
            sf.addReleaseFocusButton(data.participant);
        } catch (error) {
            console.log("Steal Focus Error",error);
        }


    };
    sleep(seconds){
        return new Promise((resolve)=>{
            setTimeout(() => {
                resolve();
            }, seconds *1000);
        })
    };
    unfocusAll(){
        var sf=this;
        console.log("Unfocusing all participnats")
        if(Object.keys(Video.focused).length > 0){
            $.each(Video.focused, function (pid) {
                Video.videos[pid].focusButton.removeClass('active');
                // Video.videos[pid].focusButton.attr('title', 'Focus');
                // Video.videos[pid].focusButton.attr('data-original-title', 'Focus');
                Video.unFocusVideo(pid,false,'',true);
            });
       }
    };
    disableStealFocus(reEnable=false){
        var sf=this;
        if(sf.btn===null){return}
        sf.btn.addClass("disabled");
        sf.enabled=false;
        if(reEnable){
            sf.reEnableFeatureDelay();
        }
    };

    reEnableFeatureDelay(delay=5000){
        var sf=this;
        sf.reUseTimeout=setTimeout(() => {
            if(sf.btn!==null){
                sf.enabled=true;
                sf.btn.removeClass('disabled');
            }
        }, delay);
    };

    showNotification(user_name,participant_id,moderator_id){
        var sf=this;
        try {
            let message=`${user_name == "You" ? "You are " : user_name+" is"} on stage`;
            let myId=room.myUserId();
            if(moderator_id!=participant_id){

                // WHO IS ON STAGE
                // let modName=moderator_id==myId ? "You" : room.getParticipantById(moderator_id).getDisplayName();
                // let userName=participant_id==myId ? "You are" : room.getParticipantById(participant_id).getDisplayName() + " is";
                // message=`${userName} on stage`;

                // WHO SET WHO ON STAGE
                let modName=moderator_id==myId ? "You" : room.getParticipantById(moderator_id).getDisplayName();
                let userName=participant_id==myId ? "you" : room.getParticipantById(participant_id).getDisplayName();
                message=`${modName} set ${userName} on stage`;
            }
            Video.showNotification(sf.focusedIconNotification,message,'stealFocusNotification',participant_id);
        } catch (error) {

        }

    };
    changeMasterVolume(volume,allowLock=false){
        try{
           volumeManager.changeMasterVolume(parseFloat(volume),false,false,false,allowLock);
           if(volume==0){
               this.volumeMutedByOnStage=true;
               volumeManager.muteVolumeOverwrite=true;
           }
        }catch(err){
            console.log("Pull focus master volume error",err);
        }

    };

    willReleaseLockFocus(participant){
        var sf=this;
        let moderators=[];
        if(sf.participantFocused==participant){
            lockFocus.stopLockFocus();
            return
        }
    };
    pullFocusOnJoin(participant,data){
        var sf=this;
        if(data!=undefined){
            if(sf.participantFocused!=null){return}
            console.error("Pull focus on join called",data)
        sf.pullfocusOnJoinTimeout=setTimeout(() => {
                if(Video.focused[data.participant]===undefined && sf.participantFocused==null){
                    let jsonData=JSON.parse(data);
                    if(Video.videos[jsonData.participant]){
                        sf.stealFocusEvent({data:jsonData});
                    }else{
                        console.error("Participant is not joined yet",jsonData);
                    }
                }
            }, 4000);

        }else if(data===undefined && participant==sf.participantFocused){

            sf.releaseFocusEvent({});
        }

    };
    isModerator(){
        return ROLE=="moderator" || HOST == 1;
    };
    addReleaseFocusButton(pid){
        let sf = this;
        let name = ''
        if(pid == room.myUserId()){
            name = 'You are on stage';
        }else{
            name = room.getParticipantById(pid).getDisplayName() + " is on stage";
        }
        if(!sf.isModerator()){
            bottomAction.onActionAdded('release-focus', name);
            bottomAction.showBottomAction();
            return
        }
        console.error(name);
        let button=$("<button/>",{
            class:'btn btn-sm btn-outline-white btn-rounded ml-2',
            id:"release-pull-focus",
            html:"Off Stage"
        });
        bottomAction.addAction('release-focus',button,(e)=>{
            console.log("release focus click");
            e.stopPropagation();
            sf.sendReleaseFocusCommand();
        },false,"before", name);
    };
    sendReleaseFocusCommand(){
        let sf = this;
        if(!sf.isModerator()){
            sf.removeReleaseFocusButton();
            return}
        try {
            // if(Object.keys(Video.videos).length >= 1){
            //     room.broadcastEndpointMessage({
            //         release_focus:"release",
            //         participant:sf.participantFocused
            //     });
            //     //
            // }
            socket.sendRawMessage({
                eventName:"ReleaseFocus",
                participant:sf.participantFocused,
                from_id: room.myUserId()
            });
            sf.releaseFocusEvent({});
            if(!sf.focusWasLocked){
                lockFocus.stopLockFocus();
            }
            // if(!sf.masterVolumeLockPreviousState){
                Video.lockMasterVolume.enableMasterVolume(true);
            // }
        } catch (error) {
            console.error("error sending release message",error);
        }
    }
    removeReleaseFocusButton(){
        bottomAction.removeAction('release-focus');
    };
    releaseFocusEvent(message){
        let sf = this;
        console.error("Release focus event received",message);
        clearTimeout(sf.pullfocusOnJoinTimeout);
        sf.setFocusedOnMe(false);
        if(sf.participantFocused!=room.myUserId() && Video.focused[sf.participantFocused] && !Video.focused[sf.participantFocused].focusOnMe && !CONV_STORAGE.myConversation){
            Video.unFocusVideo(sf.participantFocused,false,'',true);
            kinoParticipants.setAllAsUnFocusedMe();
        }else if(sf.participantFocused==room.myUserId()){
            if(!CONV_STORAGE.myConversation){
                kinoParticipants.setAllAsUnFocusedMe();
            }
        }

        sf.participantFocused=null;
        Video.announcement.muteOnStopAnnouncing=false;
        sf.removeReleaseFocusButton();
        if(volumeManager.masterMuted && (!volumeManager.muteVolumeOverwrite || sf.volumeMutedByOnStage)){
            if(sf.volumeMutedByOnStage){
                volumeManager.muteVolumeOverwrite=false;
            }
            volumeManager.changeMasterVolume(1);
        }
    };
    modAccessAdded(){
        let sf = this;
        sf.renderPullFocusButtons();
        try {
            if(sf.focusedOnMe || (sf.participantFocused && sf.participantFocused != room.myUserId())){
                sf.addReleaseFocusButton(sf.participantFocused);
            }
        } catch (error) {
            console.error(error);
        }

    }
    isFocusPulled(){
        let sf = this;
        if(sf.focusedOnMe || (sf.participantFocused && sf.participantFocused != room.myUserId())){
            return true;
        }
        return false;
    }
    modAccessRemoved(){
        this.removeReleaseFocusButton();
        this.hidePullFocusButtons();
    }

    renderPullFocusButtons(){
        // console.error("render_PullFocus_buttons");
        if (this.btn == null || !this.isModerator()) {
            return
        }
        // console.error("render_PullFocus_buttons loop");
        Object.keys(Video.videos).map(async (pid)=>{
            Video.videos[pid].showPullFocusButton();
        });
    };

    hidePullFocusButtons(){
        Object.keys(Video.videos).map(async (pid)=>{
            Video.videos[pid].hidePullFocusButton();
        });
    }

    openModalToPresetUser(pid){
        let sf = this;
        let timeout
        // console.error('Participant id is: ', pid)
        timeout = setTimeout(() => {
            if(pid){
                sf.showStealFocusModal();
                sf.participantsList.val(pid).attr('selected_id', pid);
            }
            clearTimeout(timeout);
        }, 50);
    }

    setMicMuted() {
        try {
            if (!room.getLocalAudioTrack()) {return}
            if (!room.getLocalAudioTrack().isMuted()) {
                muteMic();
            }
        } catch (e) {
            console.log("Can not mute audio");
        }
    }

    onPreferencesLoaded(){
        //master volume
        if(this.preferences['masterVolume']!==undefined){
            this.masterVolumeValue.val(this.preferences.masterVolume);
            this.masterVolumeValue.trigger('input');
        }else{
            this.masterVolumeValue.val(0.05);
            this.masterVolumeValue.trigger('input');
        }
        //mute all
        if(this.preferences['muteAll']!==undefined){
            this.muteAllCheckBox.prop('checked',this.preferences.muteAll).trigger('change');
        }else{
            this.muteAllCheckBox.prop('checked',false).trigger('change');
        }
        //lock master volume
        if(this.preferences['lockMasterVolume']!==undefined){
            this.lockMasterVolumeOnStage.prop('checked', this.preferences['lockMasterVolume'])
        }
        //timer
        if(this.preferences['timer']!==undefined){
            if(!this.preferences.timer){
                this.timerComponent.showTimerSwitchInput.prop('checked',false).trigger('change');
            }else{
                this.timerComponent.showTimerSwitchInput.prop('checked',true).trigger('change');
                this.timerComponent.showTimesUpInput.prop('checked',this.preferences.timer.showNotification).trigger('change');
                // this.timerComponent.notificationTimeInput.val(this.preferences.timer.notificationShowTime);
                this.timerComponent.notificationTimeInputMinutes.val(this.preferences.timer.notificationShowTimeMinutes ? this.preferences.timer.notificationShowTimeMinutes : '00');
                this.timerComponent.notificationTimeInputSeconds.val(this.preferences.timer.notificationShowTimeSeconds ? this.preferences.timer.notificationShowTimeSeconds : '10');
                this.timerComponent.playSoundCountdownInput.prop('checked',this.preferences.timer.playNotificationSound).trigger('change');
                this.timerComponent.minutesInput.val(this.preferences.timer.minutes? this.preferences.timer.minutes : '00').trigger('input');
                this.timerComponent.secondsInput.val(this.preferences.timer.seconds? this.preferences.timer.seconds : '30').trigger('input');

            }
        }else{
            this.timerComponent.showTimerSwitchInput.prop('checked',false).trigger('change');
            this.timerComponent.showTimesUpInput.prop('checked',true).trigger('change');
            // this.timerComponent.notificationTimeInput.val(10);
            this.timerComponent.playSoundCountdownInput.prop('checked',true).trigger('change');
            this.timerComponent.minutesInput.val('00').trigger('input');
            this.timerComponent.secondsInput.val('30').trigger('input');
        }

    };
    setNewPreferences(preferences){
        this.preferences=preferences;
        userPreferences.storeNewPreferences('pull_focus',preferences);
    };

    renderMicMutedModal() {
        let t = this;
        if(t.micMutedModal){t.removeModal(t.micMutedModal)}

        let micMutedText = $("<span/>", {
            class: 'mb-3 mic-muted-text',
            html: 'You\'re now on stage. Please unmute your microphone.',
        });
        let micMutedIcon = $("<span/>", {
            class: 'mb-3',
            html: '<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_f_1880_937)"><circle cx="50" cy="50" r="34" fill="#A01E1E"/></g><circle cx="50.5" cy="50.5" r="37.5" fill="#032836"/><path d="M59.0886 49.0253C59.0886 52.1645 56.5116 54.7329 53.3618 54.7329H47.635C44.4853 54.7329 41.9082 52.1645 41.9082 49.0253V35.7076C41.9082 32.5684 44.4853 30 47.635 30H53.3618C56.5116 30 59.0886 32.5684 59.0886 35.7076V49.0253Z" fill="white"/><path d="M48.5898 58.5391H52.4077V68.0517H48.5898V58.5391Z" fill="white"/><path d="M60.9983 67.0978C60.9983 67.0978 55.2715 65.1953 50.4991 65.1953C45.7268 65.1953 40 67.0978 40 67.0978V69.0004H60.9983V67.0978Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M41.9082 35.709H49.5439V37.6115H41.9082V35.709ZM59.0886 35.709H51.4529V37.6115H59.0886V35.709ZM49.5439 39.514H41.9082V41.4166H49.5439V39.514ZM51.4529 39.514H59.0886V41.4166H51.4529V39.514ZM49.5439 43.3191H41.9082V45.2216H49.5439V43.3191ZM51.4529 43.3191H59.0886V45.2216H51.4529V43.3191ZM41.9082 47.1242H49.5439V49.0267H41.9082V47.1242ZM59.0886 47.1242H51.4529V49.0267H59.0886V47.1242Z" fill="#093646"/><path d="M52.4081 59.4879H48.5902C45.6314 59.4879 40 57.8708 40 51.8778V43.3164H41.9089V51.8778C41.9089 57.4903 48.3039 57.5854 48.5902 57.5854H52.4081C52.6944 57.5854 59.0894 57.4903 59.0894 51.8778V43.3164H60.9983V51.8778C60.9983 57.8708 55.3669 59.4879 52.4081 59.4879Z" fill="white"/><path d="M34 33L67.6193 66.6193" stroke="white" stroke-width="3.20184"/><defs><filter id="filter0_f_1880_937" x="0" y="0" width="100" height="100" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="8" result="effect1_foregroundBlur_1880_937"/></filter></defs></svg>',

        });
        let micMutedContainer = $("<div/>", {
            class: 'd-flex align-items-center mic-muted-container',
            html: [micMutedIcon, micMutedText],
        });
        let modalBody = $("<div/>", {
            class: 'modal-body mx-auto p-0',
            html: micMutedContainer
        });

        let cancelMicMutedBtn = $('<button/>',{
            class: "btn btn-primary kino-btn-secondary",
            type: "button",
            html: "cancel",
            'data-dismiss': "modal"
        });
        let startMicMuted = $('<button/>', {
            class: "btn btn-primary kino-btn-primary",
            type: "button",
            html: "Unmute"
        }).on('click', ()=>{
            muteMicButton.trigger('click');
            t.micMutedModal.modal('hide');
        });
        let startCancelButtons = $("<div/>", {
            class: '',
            html: [cancelMicMutedBtn, startMicMuted]
        });
        let modalFooter = $("<div/>", {
            class: "modal-footer border-0",
            html: startCancelButtons
        });

        let closeModalBtn = $("<button/>", {
            class: "close-button-modal-kino",
            type: "button",
            html: `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19
            0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34
            120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12
            3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12
            3.12-8.19 0-11.31L193.94 256z"></path>
        </svg>`
        }).on('click', e => {
            t.micMutedModal.modal('hide');
        });
        let modalHeader = $("<div/>", {
            class: "modal-header modal-header-kino",
            html: [`<h4 class="modal-title text-center ignore-drag">Your Microphone is Muted</h4>`, closeModalBtn]
        });

        let modalContent = $("<div/>", {
            class: 'modal-content',
            html: [modalHeader, modalBody, modalFooter]
        });

        let modalDialog = $("<div/>", {
            class: "modal-dialog modal-dialog-centered modal-inside-kino",
            role: "document",
            html: modalContent
        });

        t.micMutedModal = $("<div/>", {
            class: "modal modal-inside-kino fade",
            id: "MicMutedPullFocusModal",
            tabindex: "-1",
            role: "dialog",
            'aria-labelledby': "kinoScreenSharePlaceOnStageModal",
            'aria-hidden': "true",
            'data-backdrop': "static",
            'data-keyboard': "false",
            html: modalDialog
        }).on('keyup',function(e){
            if (e.keyCode == 27) {
                t.micMutedModal.modal('hide');
             }
        });

        $('body').append(t.micMutedModal);
        t.micMutedModal.modal('show');
    }

    renderScreenSharePlaceOnStageModal() {
        let t = this;
        if(t.screenShareModal){t.removeModal(t.screenShareModal)}

        let shareScreenBodyText = $("<div/>", {
            class: 'd-flex mb-4 ignore-drag',
            html: 'Sharing screen on stage will use your On Stage settings from your the last time you used the On Stage feature.',
        });
        let onStageIcon = $('<span/>',{
            class: 'mr-1',
            type: "button",
            // html: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 12H8M12 8V12V8ZM12 12V16V12ZM12 12H16H12Z" stroke="#032836" stroke-width="2" stroke-linecap="round"/><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#032836" stroke-width="2"/></svg>'
            // html: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1436_453)"><path d="M21.0001 17.016L21.0001 5.016L3.00015 5.016L3.00015 17.016L21.0001 17.016ZM21.0001 3C22.0786 3 23.0161 3.9375 23.0161 5.016L22.9689 17.016C22.9689 18.0945 22.0779 18.9847 21.0001 18.9847L15.9841 18.9847L15.9841 21.0007L8.0154 21.0007L8.0154 18.9847L2.9994 18.9847C1.9209 18.9847 0.983398 18.0937 0.983398 17.016L0.983398 5.016C0.983398 3.9375 1.9209 3 2.9994 3L20.9994 3L21.0001 3Z" fill="#032836"/><path d="M12 5.00018C7.8 5.00018 11 5.00012 3 5.00023C3 8.18023 3 12 3 17C3.36 17.32 20.6398 17.32 20.9998 17C20.9998 11.5 20.9998 8.18021 20.9998 5.00021C14 4.99996 16.2 5.00018 12 5.00018ZM7.68977 13.49C8.87977 12.56 10.3698 12 11.9998 12C13.6298 12 15.1198 12.56 16.3098 13.49C15.4498 14.98 13.8498 16 11.9998 16C10.1498 16 8.54977 14.98 7.68977 13.49ZM11.9998 7.00002C13.0998 7.00002 13.9998 7.90001 13.9998 9.00001C13.9998 10.1 13.0998 11 11.9998 11C10.8998 11 9.99977 10.1 9.99977 9.00001C9.99977 7.90001 10.8998 7.00002 11.9998 7.00002Z" fill="#032836"/></g><defs><clipPath id="clip0_1436_453"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>'
            html: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1436_453)"><path d="M21.0001 17.016L21.0001 5.016L3.00015 5.016L3.00015 17.016L21.0001 17.016ZM21.0001 3C22.0786 3 23.0161 3.9375 23.0161 5.016L22.9689 17.016C22.9689 18.0945 22.0779 18.9847 21.0001 18.9847L15.9841 18.9847L15.9841 21.0007L8.0154 21.0007L8.0154 18.9847L2.9994 18.9847C1.9209 18.9847 0.983398 18.0937 0.983398 17.016L0.983398 5.016C0.983398 3.9375 1.9209 3 2.9994 3L20.9994 3L21.0001 3Z" fill="#032836"/><path d="M12.0001 6.00007C8.26672 6.00007 11.1112 6.00003 4 6.00012C4 8.65012 4 11.8333 4 16C8.00005 16 17.7779 16 20 16C20 11.4166 20 8.65011 20 6.0001C13.7779 5.99989 15.7335 6.00007 12.0001 6.00007ZM8.16874 13.075C9.22653 12.3 10.551 11.8333 11.9999 11.8333C13.4488 11.8333 14.7733 12.3 15.8311 13.075C15.0666 14.3166 13.6444 15.1666 11.9999 15.1666C10.3554 15.1666 8.93319 14.3166 8.16874 13.075ZM11.9999 7.66661C12.9777 7.66661 13.7777 8.41661 13.7777 9.33328C13.7777 10.2499 12.9777 10.9999 11.9999 10.9999C11.0221 10.9999 10.2221 10.2499 10.2221 9.33328C10.2221 8.41661 11.0221 7.66661 11.9999 7.66661Z" fill="#032836"/></g><defs><clipPath id="clip0_1436_453"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>'
        });
        let onStageText = $("<span/>", {
            class: 'kino-btn-secondary',
            type: "button",
            html: 'View my \'Stage View\' settings',
            style: 'text-transform: none;'
        });
        let onStageButton = $('<div/>',{
            class: 'd-flex align-items-center',
            html: [onStageIcon, onStageText]
        }).on('click', ()=>{
            t.screenShareModal.modal('hide');
            t.showStealFocusModal();
        });
        let onStageContainer = $("<div/>", {
            class: 'mb-4 d-flex',
            html: onStageButton,
        });
        let modalBody = $("<div/>", {
            class: 'modal-body mx-auto p-0',
            html: [shareScreenBodyText, onStageContainer],
            style: 'width: 90%;'
        });
        let labelDoNotShowAgain = $('<label/>',{
            class: 'mb-0',
            for: 'do_not_show_again',
            html: 'Do not show again'
        });
        let doNotShowAgainInput = $('<input/>',{
            class: '',
            name: 'do_not_show_again',
            id: 'do_not_show_again',
            type: 'checkbox',
            style: 'accent-color: #032836; width: 15px; height: 15px; margin: 0 5px 0 12px;'
            // checked:
        });
        let doNotShowAgainContainer = $('<div/>',{
            class: 'd-flex align-items-center justify-content-end flex-row-reverse',
            html: [labelDoNotShowAgain, doNotShowAgainInput]
        });
        let doNotShowAgain = $('<div/>', {
            class: 'd-flex flex-column ignore-drag',
            html: [doNotShowAgainContainer]
        });
        let cancelScreenShareFocusBtn = $('<button/>',{
            class: "btn btn-primary kino-btn-secondary",
            type: "button",
            html: "cancel",
            'data-dismiss': "modal"
        });
        let startShareScreen = $('<button/>', {
            class: "btn btn-primary kino-btn-primary",
            type: "button",
            html: "Share Screen"
        }).on('click', ()=>{
            // console.log("Clicked Screen Share Place on Stage")
        });
        let startCancelButtons = $("<div/>", {
            class: '',
            html: [cancelScreenShareFocusBtn, startShareScreen]
        });
        let modalFooter = $("<div/>", {
            class: "modal-footer border-0 justify-content-between",
            html: [doNotShowAgain, startCancelButtons]
        });

        // let minimizeModalBtn = $('<button/>',{
        //     class: "close-button-modal-kino minimize-button",
        //     type: "button",
        //     html: `<i class="fas fa-window-minimize"></i>`
        // }).on('click', ()=>{
        //     // Video.minimizedContent.minimizeModal('pullFocusModal', t.focusedIconNotification)
        // });
        let closeModalBtn = $("<button/>", {
            class: "close-button-modal-kino",
            type: "button",
            html: `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19
            0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34
            120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12
            3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12
            3.12-8.19 0-11.31L193.94 256z"></path>
        </svg>`
        }).on('click', e => {
            t.screenShareModal.modal('hide');
        });
        let modalHeader = $("<div/>", {
            class: "modal-header modal-header-kino",
            html: [`<h4 class="modal-title text-center ignore-drag">Share Screen on Stage</h4>`, closeModalBtn]
            // html: [`<h4 class="modal-title text-center ignore-drag">Share Screen on Stage</h4>`, minimizeModalBtn, closeModalBtn]
        });

        let modalContent = $("<div/>", {
            class: 'modal-content',
            html: [modalHeader, modalBody, modalFooter]
        });

        let modalDialog = $("<div/>", {
            class: "modal-dialog modal-dialog-centered modal-inside-kino",
            role: "document",
            html: modalContent
        });

        t.screenShareModal = $("<div/>", {
            class: "modal modal-inside-kino fade",
            id: "kinoScreenSharePlaceOnStageModal",
            tabindex: "-1",
            role: "dialog",
            'aria-labelledby': "kinoScreenSharePlaceOnStageModal",
            'aria-hidden': "true",
            'data-backdrop': "static",
            'data-keyboard': "false",
            html: modalDialog
        }).on('hidden.bs.modal', function(){
            //here you can add any additional functionality when modal is being closed
        }).on('shown.bs.modal', function(e){
            //here you can add any additional functionality when modal is being opened
        }).on('keyup',function(e){
            if (e.keyCode == 27) {
                t.screenShareModal.modal('hide');
             }
        });

        $('body').append(t.screenShareModal);
        t.screenShareModal.modal('show');
    }

    showLockOnStageActiveNotification(){
        var sf = this;
        console.error("Stage View is currently active");
        Video.showNotification(sf.focusedIconNotification,`Stage View is currently active, Spaces are locked`,'onStageActiveNotification',room.myUserId());
    };
};
